import { Phone } from "lucide-react";

export default function FloatingCall({ contact }) {
  const dial = contact?.phone_dial || "+4962515504920";
  return (
    <a
      href={`tel:${dial}`}
      data-testid="floating-call-btn"
      className="lg:hidden fixed bottom-5 right-5 z-40 mf-cta shadow-2xl px-5 py-4"
      aria-label="Jetzt anrufen"
    >
      <Phone size={20} strokeWidth={2.4} />
      <span className="font-head font-semibold">Anrufen</span>
    </a>
  );
}
